import { Chart } from 'primereact/chart'; // Actuellement PrimeReact
// Futur: import { BarChart } from '@mui/x-charts/BarChart';
import { getStableColor } from '../analyticsColors';

function BarChart({ data, config }) {
  if (!data || !data.labels || !data.datasets?.length) {
    return null;
  }
  // Configuration des options (reste similaire)
  const chartOptions = {
    scales: {
      x: { stacked: true },
      y: { stacked: true }
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: config.displayType === 'secondary' ? false : true
      }
    }
  };

  const datasets = data.datasets.map((dataset) => {
    const color = getStableColor(dataset.label);

    return {
      ...dataset,

      backgroundColor: color,
      borderColor: color,

      borderWidth: 1,
      borderRadius: 3,
      width: "100%",
      borderColor: "#ffffff",
      // Permet de garder les propriétés éventuellement
      // fournies par le backend.
      // hoverBackgroundColor: color,
      // hoverBorderColor: color
    };
  });

  const chartData = {
    labels: data.labels,
    datasets
  };



  // NOTE POUR LA MIGRATION MUI :
  // Quand vous passerez à MUI, vous garderez ce composant, 
  // mais vous remplacerez simplement le <Chart /> par le composant MUI.
  // La structure des props (data, config) restera la même.

  return (
    <Chart
      type="bar"
      data={chartData}
      options={chartOptions}
      height={config.displayType === 'secondary' ? 200 : 600}
      className=" w-full"
    />
  );
}

export default BarChart;